import React, { useEffect, useState } from 'react';
import FooterClasses from './AppFooter.module.css';

function VersionDisplay() {
  const [version, setVersion] = useState('');

  useEffect(() => {
    fetch('/release.json')
      .then(response => {
        if (!response.ok) throw new Error('Failed to fetch release.json');
        return response.json();
      })
      .then(data => {
		  const match = data.VERSION.match(/\d+/);
		  const revision = match ? match[0] : null;
        setVersion(revision);
      })
      .catch(error => {
        console.error('Error loading version:', error);
      });
  }, []);

  return (
    <div className={FooterClasses.navAreaText}>
      DTC.{version || 'Loading...'}
    </div>
  );
}

export default VersionDisplay;
